import { render } from "./Medal.vue?vue&type=template&id=76cc9350&ts=true"
import script from "./Medal.vue?vue&type=script&lang=ts"
export * from "./Medal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__